package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.NewsstandW500Rounded: ImageVector
    get() {
        if (_newsstandW500Rounded != null) {
            return _newsstandW500Rounded!!
        }
        _newsstandW500Rounded = Builder(name = "NewsstandW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(110.91f, 805.5f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.17f)
                quadTo(65.41f, 779.15f, 65.41f, 760.0f)
                reflectiveQuadToRelative(13.18f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.32f, -13.17f)
                horizontalLineToRelative(738.18f)
                quadToRelative(19.15f, 0.0f, 32.32f, 13.17f)
                quadToRelative(13.18f, 13.18f, 13.18f, 32.33f)
                reflectiveQuadToRelative(-13.18f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.32f, 13.17f)
                lineTo(110.91f, 805.5f)
                close()
                moveTo(153.09f, 626.83f)
                quadToRelative(-13.18f, -13.18f, -13.18f, -32.33f)
                verticalLineToRelative(-240.0f)
                quadToRelative(0.0f, -19.15f, 13.18f, -32.33f)
                quadTo(166.26f, 309.0f, 185.41f, 309.0f)
                reflectiveQuadToRelative(32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                verticalLineToRelative(240.0f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.33f)
                quadTo(204.56f, 640.0f, 185.41f, 640.0f)
                reflectiveQuadToRelative(-32.32f, -13.17f)
                close()
                moveTo(320.26f, 626.83f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                verticalLineToRelative(-400.0f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadTo(333.43f, 149.0f, 352.59f, 149.0f)
                quadToRelative(19.15f, 0.0f, 32.32f, 13.17f)
                quadToRelative(13.18f, 13.18f, 13.18f, 32.33f)
                verticalLineToRelative(400.0f)
                quadToRelative(0.0f, 19.15f, -13.18f, 32.33f)
                quadTo(371.74f, 640.0f, 352.59f, 640.0f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.17f)
                close()
                moveTo(487.67f, 626.83f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                verticalLineToRelative(-400.0f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadTo(500.85f, 149.0f, 520.0f, 149.0f)
                reflectiveQuadToRelative(32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                verticalLineToRelative(400.0f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.33f)
                quadTo(539.15f, 640.0f, 520.0f, 640.0f)
                reflectiveQuadToRelative(-32.33f, -13.17f)
                close()
                moveTo(808.63f, 617.37f)
                quadToRelative(-16.15f, 9.2f, -34.8f, 4.1f)
                quadToRelative(-18.66f, -5.1f, -27.85f, -21.25f)
                lineTo(626.22f, 389.98f)
                quadToRelative(-9.2f, -16.15f, -4.1f, -34.81f)
                quadToRelative(5.1f, -18.65f, 21.25f, -27.84f)
                quadToRelative(16.15f, -9.2f, 34.8f, -4.1f)
                quadToRelative(18.66f, 5.1f, 27.85f, 21.25f)
                lineToRelative(119.76f, 210.24f)
                quadToRelative(9.2f, 16.15f, 4.1f, 34.8f)
                reflectiveQuadToRelative(-21.25f, 27.85f)
                close()
            }
        }
        .build()
        return _newsstandW500Rounded!!
    }

private var _newsstandW500Rounded: ImageVector? = null
